import React, { Suspense, lazy } from 'react';
import { Spin } from 'antd';

// 加载中组件
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '400px' 
  }}>
    <Spin size="large" />
  </div>
);

// 错误边界组件
class LazyErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Lazy loading error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          minHeight: '400px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <h3>页面加载失败</h3>
          <p>请刷新页面重试</p>
        </div>
      );
    }

    return this.props.children;
  }
}

// 懒加载组件包装器
export function createLazyComponent(importFn) {
  const LazyComponent = lazy(importFn);
  
  return function WrappedLazyComponent(props) {
    return (
      <LazyErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <LazyComponent {...props} />
        </Suspense>
      </LazyErrorBoundary>
    );
  };
}

export default LazyErrorBoundary;
